<template>

  <!-- Fullscreen Slides Element -->
  <div
    class="fullscreen-slides-element">

    <!-- Background -->
    <file-background
      no-placeholder
      :value="value.file"
      :color="value.bgColor"
      :class="{ghost: hasText}"
      class="fullscreen-slides-element__background"/>

    <!-- Content -->
    <page-block
      :style="contentStyles"
      overlay-class="max-width-100"
      class="fullscreen-slides-element__content">

      <div
        class="fullscreen-slides-element__wrapper">

        <!-- Title -->
        <div
          v-if="hasTitle"
          v-html="value.title.ru"
          class="fullscreen-slides-element__title"/>

        <!-- Body -->
        <div
          v-if="hasBody"
          v-html="value.body.ru"
          class="fullscreen-slides-element__body"/>

        <!-- Buttons -->
        <page-block-buttons
          :value="value.buttons"/>

      </div>

    </page-block>

  </div>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageElementMixin from '@src/mixins/page-element-mixin';
  import FileBackground from '@src/components/file/file-background';
  import PageBlockButtons from '@src/components/page/page-block-buttons';

  export default {
    name: 'fullscreen-slides-element',
    mixins: [
      PageElementMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      FileBackground,
      PageBlockButtons,
    },
    computed: {
      contentStyles() {

        return {
          color: this.value.textColor,
          textAlign: this.value.textAlign,
        };
      },
      hasText() {

        if (!this.value)
          return false;

        return !!(
          this.hasTitle ||
          this.hasBody ||
          this.hasButtons
        );
      },
    },
  };

</script>

<style lang="scss">

  .fullscreen-slides-element {
    width: 100%;
    height: 100vh;
    min-height: 500px;
    position: relative;

    &__content,
    &__background {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    &__background {
      background-color: $primary;
    }

    &__background.ghost > * {
      opacity: .5;
    }

    &__content {
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__wrapper {
      max-width: 720px;
      display: inline-block;
    }

    &__title {
      font-size: 3rem;
      font-weight: 600;
      line-height: 3.5rem;
    }

    &__body {
      font-size: 1.3rem;
    }

    &__wrapper > * {
      margin-bottom: 0;
    }

    &__wrapper > *:not(:first-child) {
      margin-top: $spacer-lg;
    }

    @media (max-width: $breakpoint-xs) {

      &__title {
        font-size: 1.5rem;
        line-height: 2rem;
      }

      &__body {
        font-size: 1rem;
      }

      &__wrapper > *:not(:first-child) {
        margin-top: $spacer-sm;
      }
    }
  }

</style>
